export default __webpack_public_path__ + "static/media/attendance-aceite.67023564.svg";